import * as React from "react";
import SelectComponent from "../../ui/select/SelectComponent";
import Merchant from "../../../model/merchant/Merchant";

export default class SelectMerchant extends SelectComponent<Merchant> {
	matchFilter(element: Merchant, filter: string): boolean {
		return element.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Merchant): string {
		return element.id;
	}

	elementToString(element: Merchant) {
		return element.name;
	}
}